__webpack_require__.p = "/would-you-rather/";